import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IDashboardCards } from "../../../Pages/AdminDashboard/IDashboard";

export const DashboardCalenderDataSlice = createSlice({
  name: "DashboardCalenderDataSlice",
  initialState: {} as IReduxState<IDashboardCards>,
  reducers: {
    dashboardCalenderData: (state) => {
      state.isLoading = true;
    },
    successDashboardCalenderData: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureDashboardCalenderData: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearDashboardCalenderData: (state) => {
      state.data = {};
    },
  },
});

export const {
  failureDashboardCalenderData,
  successDashboardCalenderData,
  clearDashboardCalenderData,
  dashboardCalenderData,
} = DashboardCalenderDataSlice.actions;

export default DashboardCalenderDataSlice.reducer;
